module.exports = __webpack_public_path__ + "static/diy_recipe_dropbear_mobile-cc2e8c56ff722d18b5b000a24892460b.pdf";